import { App } from 'antd';
import Icon from '../../cpn/Icon';
import {  useDingdanshouruDelMutation } from '../../store/DianShangYeWuApi';   
function IncomeDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useDingdanshouruDelMutation()  
    return (
        <Icon type='delete'  onClick={() => {
            if (!props.ddsr_id) {
                message.error('缺少必要的ID参数');
                return;
            }
            modal.confirm({
                title: '点击确定删除收款单',
                content: '删除后不能恢复！',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    submitDel({
                        ddsr_id:props.ddsr_id+'',
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('删除成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('删除失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}/>
    )
}

export default IncomeDel